import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SelectionButtonSizeEnum } from '../enums';

@Component({
  selector: 'symphony-solo-selection-button',
  templateUrl: './selection-button.component.html',
  styleUrls: ['./selection-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionButtonComponent {
  @Input() public selectTitle: string;
  @Input() public icon: string;
  @Input() public size: SelectionButtonSizeEnum;
  @Input() public isDisabled = false;

  public getStyleClass(): string {
    let classList = this.getGradient();
    classList += this.size === SelectionButtonSizeEnum.Small ? ' small' : ' big';
    classList += this.isDisabled ? ' disabled' : '';
    return classList;
  }

  public getGradient(): string {
    const gradientArray = ['first-gradient', 'second-gradient', 'third-gradient'];
    return gradientArray[Math.floor(Math.random() * gradientArray.length)];
  }
}
